"use client";

import type {
  CarePlusInquiry as CarePlusInquiryProps,
  PlaceholderValues,
} from "@homeinstead/schemas";
import type { PortableTextBlock } from "next-sanity";

import { CarePlusLeadForm } from "~www/components/LeadForm/CarePlus";
import { InquiryIntroSection } from "~www/components/LeadForm/Inquiry";

export interface CarePlusInquiryBlockProps
  extends Omit<CarePlusInquiryProps, "_type"> {
  /** Set by `Content` */
  placeholders?: PlaceholderValues;
}

function CarePlusInquiry({
  initialStep,
  textColor,
}: CarePlusInquiryBlockProps) {
  if (!initialStep?.length) {
    return null;
  }

  return (
    <InquiryIntroSection
      ctaElementName="get_care_plus"
      ctaLabel="Get Care+"
      initialStep={initialStep as PortableTextBlock[]}
      textColor={textColor}
    >
      <CarePlusLeadForm textColor={textColor} />
    </InquiryIntroSection>
  );
}

export { CarePlusInquiry };
